export enum LoginState {
    SignIn = 'SIGN_IN',
    SignUp = 'SIGN_UP',
    ForgotPassword = 'FORGOT_PASSWORD',
    NewPlayerRegistration = 'NEW_PLAYER_REGISTRATION',
    ExistingPlayerLinking = 'EXISTING_PLAYER_LINKING',
    EmailConfirmation = 'EMAIL_CONFIRMATION',
    VerifyDetails = 'VERIFY_DETAILS',
    SetPassword = 'SET_PASSWORD',
    NewPasswordRequired = 'NEW_PASSWORD_REQUIRED',
    MfaSelection = 'MFA_SELECTION',
    MfaOtpVerification = 'MFA_OTP_VERIFICATION',
    MfaResetOtp = 'MFA_RESET_OTP'
  }